import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';

const worlds = [
  { world: 'Earth', population: '~3 billion', role: 'Recovering biosphere, political and historical center', color: 'text-green-400', dot: 'bg-green-400' },
  { world: 'Mercury', population: '450,000', role: 'Energy and quantum crystal production; powers the solar system', color: 'text-orange-400', dot: 'bg-orange-400' },
  { world: 'Venus', population: '1 million', role: 'Terraformed paradise; warm oceans, amber skies, black sand beaches', color: 'text-amber-400', dot: 'bg-amber-400' },
  { world: 'Mars', population: '~10 million', role: 'First independent planetary republic', color: 'text-red-400', dot: 'bg-red-400' },
  { world: 'The Belt', population: '200,000', role: 'Shipping and resilience; "the ligaments of the solar system"', color: 'text-gray-400', dot: 'bg-gray-400' },
  { world: 'Jupiter System', population: '1.3 million', role: 'Helium-3 fuel, water exports, Europa\'s sacred biosphere', color: 'text-yellow-400', dot: 'bg-yellow-400' },
  { world: 'Saturn System', population: '520,000', role: "Titan's artists and flyers; Enceladus custodianship", color: 'text-purple-400', dot: 'bg-purple-400' },
  { world: 'Neptune / Triton', population: '~50,000', role: 'The last lighthouse; gateway to interstellar space', color: 'text-blue-400', dot: 'bg-blue-400' },
];

const WorldTable = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <SectionHeading title="The Eight Inhabited Worlds" subtitle="Solar Civilization" />

      {/* Desktop Table */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="hidden md:block bg-brand-surface border border-white/5 rounded-2xl overflow-hidden"
      >
        <table className="w-full">
          <thead>
            <tr className="border-b border-white/10 bg-white/5">
              <th className="text-left px-6 py-4 text-brand-accent font-semibold text-sm uppercase tracking-widest">World</th>
              <th className="text-left px-6 py-4 text-brand-accent font-semibold text-sm uppercase tracking-widest">Population</th>
              <th className="text-left px-6 py-4 text-brand-accent font-semibold text-sm uppercase tracking-widest">Role in Civilization</th>
            </tr>
          </thead>
          <tbody>
            {worlds.map((row, i) => (
              <tr key={i} className="border-b border-white/5 last:border-0 hover:bg-white/3 transition-colors">
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <span className={`w-2 h-2 rounded-full flex-shrink-0 ${row.dot}`}></span>
                    <span className={`font-display font-bold ${row.color}`}>{row.world}</span>
                  </div>
                </td>
                <td className="px-6 py-4 text-white font-medium">{row.population}</td>
                <td className="px-6 py-4 text-gray-400 text-sm leading-relaxed">{row.role}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </motion.div>

      {/* Mobile Cards */}
      <div className="md:hidden space-y-4">
        {worlds.map((row, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.05 }}
            className="bg-brand-surface border border-white/5 rounded-xl p-5"
          >
            <div className="flex items-center gap-3 mb-2">
              <span className={`w-2 h-2 rounded-full flex-shrink-0 ${row.dot}`}></span>
              <span className={`font-display font-bold text-lg ${row.color}`}>{row.world}</span>
            </div>
            <p className="text-white font-semibold text-sm mb-1">{row.population}</p>
            <p className="text-gray-400 text-sm leading-relaxed">{row.role}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default WorldTable;